import { coverInstruction } from "@constants/instructionConstants";
import { virtualAssistanceOcularMotilityConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  WaitDuration,
  TestUIConfiguration,
} from "types/testTypes";
import { CATEGORY_VERSION_MAP, TEST_TYPE_VERSION_MAP } from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
  CALIBRATION_TOGGLE_OPTION_NEW_APK,
} from "../configurationHelperConstants";

export const availableCoverTestConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    configurationFieldName: "testType",
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.Cover],
    choices: [
      {
        validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.CoverUncover],
        value: TestType.CoverUncover,
      },
      {
        validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.ObjectivePhoria],
        value: TestType.ObjectivePhoria,
      },
    ],
  },
  eyeConfigurationOptions: {
    ...AVAILABLE_EYE_OPTIONS_BINOCULAR,
    toggleCalibrationOption: { ...CALIBRATION_TOGGLE_OPTION_NEW_APK },
  },
  languageOptions: null,
  virtualAssistantOptions: AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
  testSpeedOptions: null,
};

export const coverTestConfiguration: TestConfiguration = {
  name: TestCategory.Cover,
  testType: TestType.CoverUncover,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: true,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistanceOcularMotilityConfig,
  isPressToStartEnabled: true,
  extraData: null,
};

export const coverUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: coverInstruction,
};

export const CoverTestEyeMaxDistance = 0.5;
